import * as components from './components'

export default [
  {
    path: '/folderManagement',
    component: components.FolderList,
    name: 'folderList',
    props: true
  },
  {
    path: '/folderManagement/create',
    component: components.FolderCreate,
    name: 'folderCreate',
    props: true
  },
  {
    path: '/folderManagement/:uuid/edit',
    component: components.FolderEdit,
    name: 'folderEdit',
    props: true
  }
]



// WEBPACK FOOTER //
// ./src/app/folderManagement/routes.js